<template>
    <v-row>
        <v-col v-for="item in form_content"
           :key="item.id"
           cols="12"
           :md="item.md"
    >

        <v-text-field v-if="item.type === 'text-field'"
                      :label="item.label"
                      :hint="item.hint"
                      outlined
                      persistent-hint
                      v-model="booking[item.id]"
                      :counter="item.counter"
                      :rules="getRules(item)"
                      :required="item.required"
                      :disabled="disabled"
        />
        <v-textarea v-else-if="item.type === 'textarea'"
                    :label="item.label"
                    :hint="item.hint"
                    outlined
                    persistent-hint
                    v-model="booking[item.id]"
                    :counter="item.counter"
                    :rules="getRules(item)"
                    :required="item.required"
                    :disabled="disabled"
        />
        <v-select v-else-if="item.type === 'select'"
                  :label="item.label"
                  :hint="item.hint"
                  outlined
                  persistent-hint
                  v-model="booking[item.id]"
                  :items="item.items"
                  :counter="item.counter"
                  :rules="getRules(item)"
                  :required="item.required"
                  :disabled="disabled"
        />
        <v-menu v-else-if="item.type === 'date-picker'"
                transition="scale-transition"
                offset-y
                min-width="291px"
        >
            {{closeDatePicker(item.id)}}
            <template v-slot:activator="{ on }">
                <v-text-field
                        v-model="dateTempHolder[item.id]"
                        :label="item.label"
                        :hint="item.hint"
                        persistent-hint
                        outlined
                        prepend-inner-icon="event"
                        :rules="getRules(item)"
                        :required="item.required"
                        :disabled="disabled"
                        @blur="booking[item.id] = dateTempHolder[item.id]"
                        v-on="on"
                ></v-text-field>
            </template>
            <v-date-picker class="ma-0" v-model="booking[item.id]" no-title @input="closeDatePicker(item.id)"></v-date-picker>
        </v-menu>
    </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'DynamicElement',
        props: ['booking', 'form_content', 'disabled'],
        data: () => ({
            dateTempHolder: {},
        }),
        methods: {
            getRules(item) {
                let rules = [];
                if(item.validate) {
                    rules.push(v => !!v || `${item.label} is required`)
                }
                if(item.validateLength && item.counter > 0) {
                    rules.push(v => (!v || v.length <= item.counter) || `Must be less than ${item.counter} characters`)
                }
                if(item.customRules && item.customRules.length > 0){
                    rules = rules.concat(item.customRules)
                }
                return rules;
            },
            closeDatePicker(field) {
                this.dateTempHolder[field] = this.booking[field]
                return;
            },
        }
    }
</script>